// Legacy wrapper — retained so existing consumers (DailyChallenge,
// PlaylistBrowser, HeadToHead, PartyMode) keep compiling during the
// branding sweep. Delegates to the new Player. Prefer using <Player />
// directly in new code. Delete once all consumers are migrated.

import { Player } from "./Player";

interface VinylRecordProps {
  isPlaying: boolean;
  stage: number;
  revealed?: { title: string; artist: string; year?: number };
  artworkUrl?: string;
  size?: "sm" | "md";
  onToggle?: () => void;
  disabled?: boolean;
}

export function VinylRecord({ isPlaying, stage, size = "md", onToggle, disabled }: VinylRecordProps) {
  const px = size === "sm" ? 140 : 200;
  const hintsRevealed = Math.max(0, Math.min(5, stage - 1));
  return (
    <Player
      isPlaying={isPlaying}
      revealed={hintsRevealed}
      totalHints={5}
      onToggle={onToggle ?? (() => {})}
      disabled={disabled}
      size={px}
    />
  );
}
